import React from "react";
import { v4 as uuidv4 } from "uuid";
import { FiClock } from "react-icons/fi";
import { ControlPanel } from "./ControlPanel";
import { PreviewPlayer } from "./PlayerPreview";
import { PlayerDevice } from "./Player";
import { AddPreview } from "./AddPreview/AddPreview";
export const ClockWidget = {
    id: "b14018e8-2162-48e6-895d-9c16c9f0b57a",
    name: "Horloge",
    icon: React.createElement(FiClock, null),
    type: "clock",
    inHeadbar: true,
    description: "Ajout de l'heure, sous forme numérique ou analogique",
    keywords: [
        "heure",
        "minutes",
        "secondes",
        "heure",
        "horloge",
        "temps",
        "horaire",
        "time",
        "clock",
    ],
    config: null,
    createdAt: "2022-06-12T08:09:00.000Z",
    updatedAt: "2022-06-12T08:09:00.000Z",
    isActive: true,
    isDeleted: false,
    load: null,
    scope: ["font"],
    controlPanel: ControlPanel,
    playerPreview: PreviewPlayer,
    context: null,
    playerDevice: PlayerDevice,
    contextDevice: ({ children }) => React.createElement(React.Fragment, null, children),
    addWidgetPreview: AddPreview,
    height: "auto",
    factory: () => ({
        id: uuidv4(),
        data: {
            type: "numeric",
        },
    }),
    resize: {
        bottom: false,
        bottomLeft: true,
        bottomRight: true,
        left: false,
        right: false,
        top: false,
        topLeft: true,
        topRight: true,
    },
    scalePlayer: true,
};
